import React from 'react';

import Bracket from './Bracket';
import JsonLogicBuilder from './index';
import Divider from './Divider';
import Delete from './Delete';

const operators = [
  {value: 'and', label: 'And'},
  {value: 'or', label: 'Or'}
];

function LogicExpression({variables, operator, value, onChange, onCollapse}) {
  return (
    <Bracket onCollapse={onCollapse}>
      <JsonLogicBuilder
        expand
        variables={variables}
        value={value[0]}
        onChange={nextValue => onChange({[operator]: [nextValue, value[1]]})}
      />
      <Divider />
      <LogicSelector
        value={operator}
        onChange={nextOperator => onChange({[nextOperator]: value})}
      />
      <Delete onClick={() => onChange(null)} />
      <Divider />
      <JsonLogicBuilder
        expand
        variables={variables}
        value={value[1]}
        onChange={nextValue => onChange({[operator]: [value[0], nextValue]})}
      />
    </Bracket>
  );
}

function LogicSelector({value, onChange}) {
  return (
    <select value={value} onChange={e => onChange(e.target.value)}>
      {operators.map(operator => (
        <option key={operator.value} value={operator.value}>
          {operator.label}
        </option>
      ))}
    </select>
  );
}

export default LogicExpression;
